<template>
    <div>
        <div class="grid grid-cols-12 gap-4">
            <div class="col-span-11 mx-auto">
                <h3 class="text-lg"></h3>

                <div class="grid grid-cols-12 gap-4">
                    <div class="col-span-12 bg-gray-50 rounded px-2 py-2">
                        <p>
                            <label class="text-lg float-start">
                                {{ account.name }} Account Summary and Account Credit Usage
                            </label>
                            <label class="text-lg float-end">
                                <label class="text-sm">
                                    Account Balance : <span
                                        class="text-primary text-lg">UGX {{ accountBalance.toLocaleString() }}</span>
                                </label>
                            </label>


                        </p>
                    </div>
                </div>
                <div class="grid grid-cols-12 gap-4">
                    <label class="text-lg">Recent api calls </label>
                    <div class="col-span-12 bg-gray-50 rounded px-2 py-2">
                        <table class="border-1 rounded" width="100%">
                            <thead class="bg-gray-200">
                            <tr>
                                <td>#</td>
                                <td style="width: 20%">
                                    <label>Entity</label>
                                </td>
                                <td style="width: 10%">
                                    <label>Endpoint</label>
                                </td>
                                <td style="width: 5%">
                                    Feedback
                                </td>
                                <td style="width: 60%">
                                    Response
                                </td>


                            </tr>
                            </thead>

                            <tbody>

                            <tr class="border-1 border-gray" v-for="(log, idx) in logs" :key="idx">
                                <td>
                                    <label>{{ idx + 1 }}</label>
                                </td>
                                <td>
                                    <label class="text-primary text-lg">{{ JSON.parse(log.apiRequest).brn }}</label>
                                </td>
                                <td>
                                    <label>{{ log.endPoint }}</label>
                                </td>
                                <td>
                                    <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs bg-green mx-2" v-if="log.responseGiven">
                                        <i class="fa fa-check bg-green"></i>
                                        Served
                                    </span>
                                    <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs bg-red mx-2" v-else>Failed</span>

                                </td>
                                <td>

                                    <span v-if="showIndex===idx">
                                            <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs bg-primary mx-2 cursor-pointer" @click="hideApiDetails()"

                                                     v-if="log.responseGiven"> <i class="fa fa-eye-slash bg-primary"></i> Hide</span>
                                        <pre class="text-xs text-green bg-black font-mono p-2 rounded-md">{{
                                                JSON.parse(log.apiResponse).data
                                            }}</pre>

                                        </span>
                                    <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs bg-green mx-2 cursor-pointer" v-else-if="log.apiResponse"
                                             @click="showApiDetails(idx)">
                                        <i class="fa fa-eye bg-green"></i> Show
                                    </span>

                                    <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs bg-orange mx-2 cursor-pointer" v-else @click="showApiDetails(idx)">
                                        <i class="fa fa-eye-slash bg-orange"></i> N/A
                                    </span>
                                </td>
                            </tr>

                            <tr>
                                <td v-if="logs.length === 0" colspan="12" class="bg-inertgrey text-center py-1">
                                    <span class="text-sm">No results found</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>

                        <div class="grid grid-cols-12 gap-4 mx-1" v-if="pagination.totalPages> 1">
                            <div class="col-span-1">
                                <button class="btn-primary" @click="previous" :class="(currentPage > 1) ? 'btn-primary paginate-btn' :'btn-primary inert-btn'">
                                    Previous
                                </button>
                            </div>
                            <div class="col-span-1">
                                <div class="grid grid-cols-12 gap-4">
                                    <div class="col-span-12">
                                        <p class="paginate-details text-center">
                                            <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs bg-primary text-white">
                                                {{ (currentPage) }}/{{ pagination.totalPages }}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-span-1">
                                <button @click="next"
                                        :class="(currentPage < pagination.totalPages) ? 'btn-primary paginate-btn' :'btn-primary inert-btn'">
                                    Next
                                </button>
                            </div>
                            <div class="col-span-12 9"></div>
                        </div>

                    </div>
                </div>

            </div>
        </div>


    </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import { useIntegrationStore } from "@/domains/home/services/integrations/stores";

interface ApiLog {
    apiRequest: string
    endPoint: string
    responseGiven: boolean
    apiResponse: string
}

interface Account {
    id: string
    name: string
}

interface Pagination {
    totalElements: number
    totalPages: number
}

const integrationStore = useIntegrationStore();

const accountBalance = ref(0)
const logs = ref<ApiLog[]>([])
const showIndex = ref<number | null>(null)
const account = ref<Account>({ id: '', name: '' })
const loading = ref(false)
const currentPage = ref(1)
const limit = ref(10)
const pagination = ref<Pagination>({
    totalElements: 0,
    totalPages: 0
})

const rows = ref({
    odd: "border-t border-gray-200 hover:bg-gray-10",
    even: "border-t border-gray-200 bg-gray-10"
})

onMounted(() => {
    fetch()
})

const showApiDetails = (idx: number) => {
    showIndex.value = idx
}

const hideApiDetails = () => {
    showIndex.value = null
}

const next = () => {
    if (currentPage.value < pagination.value.totalPages) {
        currentPage.value++
        fetch()
    }
}

const previous = () => {
    if (currentPage.value > 1) {
        currentPage.value--
        fetch()
    } else {
        // @ts-ignore
        warningToast("Observation", "No more data to show")
    }
}

const objectToQueryParams = (obj: any) => {
    return Object.keys(obj)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
        .join('&')
}

const fetch = () => {
    loading.value = true
    account.value = JSON.parse(sessionStorage.getItem("account") || '{}')
    let data = {
        page: currentPage.value,
        perPage: limit.value,
        organisationId: account.value.id
    }

  integrationStore.fetchAccountSummary(account.value.id);
  integrationStore.fetchApiLogs(objectToQueryParams(data));
}

// Watchers
watch(() => integrationStore.accountSummary, (data) => {
    if (data && data.data) {
        accountBalance.value = data.data.accountBalance
    }
})

watch(() => integrationStore.logs, (data) => {
    if (data && data.data) {
        logs.value = data.data.content
        pagination.value.totalElements = data.data.totalElements
        pagination.value.totalPages = data.data.totalPages
        loading.value = false
    }
})
</script>
